(function (argument) {
	'use strict';

	angular.module('changdobels', [
		'ngRaven',
		'changdobels.wp-constants',
		'ngMessages'
	]).config(config).controller('AppController', angular.noop);

	config.$inject = ['$compileProvider', 'ENVIRONMENT'];
	function config($compileProvider, ENVIRONMENT) {
		if ('production' === ENVIRONMENT) {
			$compileProvider.debugInfoEnabled(false);
		}

		$compileProvider.commentDirectivesEnabled(false);
		$compileProvider.cssClassDirectivesEnabled(false);
	}
})();